import React from "react";
import { Outlet, Navigate, Link, useNavigate } from "react-router-dom";
import { LogOut, Home, LayoutDashboard } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-[#F4F6F8] text-[#64748B]">Checking session…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-[#F4F6F8]">
      <header className="bg-[#101827] text-white border-b border-[#C5A46D]/20">
        <div className="ae-container flex items-center justify-between h-16">
          <Link to="/admin" className="flex items-center gap-2.5" data-testid="admin-logo">
            <div className="w-9 h-9 rounded-md bg-gradient-to-br from-[#C5A46D] to-[#8E7340] flex items-center justify-center">
              <span className="font-display font-bold text-[#101827]">A</span>
            </div>
            <div>
              <div className="font-bold text-sm">APURBA ESTATE</div>
              <div className="text-[10px] text-[#C5A46D] tracking-[0.2em] uppercase flex items-center gap-1"><LayoutDashboard className="w-3 h-3" /> Admin</div>
            </div>
          </Link>
          <div className="flex items-center gap-2">
            <Link to="/" className="hidden sm:inline-flex ae-btn-outline !border-white/20 !text-white hover:!bg-white hover:!text-[#101827]" data-testid="admin-view-site"><Home className="w-4 h-4" /> View Site</Link>
            <div className="hidden md:flex items-center gap-2 text-xs text-white/70 px-3">
              <div className="w-8 h-8 rounded-full bg-[#C5A46D]/20 flex items-center justify-center font-semibold text-[#C5A46D]">{(user.name || "A")[0]}</div>
              <div>
                <div className="text-white font-semibold">{user.name}</div>
                <div className="text-[10px]">{user.email}</div>
              </div>
            </div>
            <button
              onClick={() => { logout(); navigate("/admin/login"); }}
              className="ae-btn-gold !py-2 !px-3 text-sm"
              data-testid="admin-logout"
            >
              <LogOut className="w-4 h-4" /> Logout
            </button>
          </div>
        </div>
      </header>
      <main className="ae-container py-8">
        <Outlet />
      </main>
    </div>
  );
}
